import { updateFilePath } from '.';

// Source and destination are two entries of fileMap, files is a list of entries 
export async function moveFiles(files, source, destination, fileMap) {
    let tryingToMoveToChildDirectory = false
    files.map(each => {
        if (each.isDir) {
            if (each.childrenIds.includes(destination.id)) {
                tryingToMoveToChildDirectory = each
            }
        }
    })
    if (tryingToMoveToChildDirectory) {
        return "childError"
    } else {
        try {
            var newFileMap = { ...fileMap };
            const moveFileIds = new Set(files.map((f) => f.id));

            // Delete files from their source folder.
            const newSourceChildrenIds = source.childrenIds.filter(
                (id) => !moveFileIds.has(id)
            );
            newFileMap[source.id] = {
                ...source,
                childrenIds: newSourceChildrenIds,
                childrenCount: newSourceChildrenIds.length - 1,
            };

            // Add the files to their destination folder.
            const newDestinationChildrenIds = [
                ...destination.childrenIds,
                ...files.map((f) => f.id),
            ];
            newFileMap[destination.id] = {
                ...destination,
                childrenIds: newDestinationChildrenIds,
                childrenCount: newDestinationChildrenIds.length - 1,
            };



            // Finally, update the parent folder ID on the files from source folder
            // ID to the destination folder ID.

            var updatedFileMap = newFileMap;

            files.forEach((file) => {
                updatedFileMap = { ...updateFilePath(file, destination.id, fileMap, updatedFileMap) };
            });

            return updatedFileMap;
        } catch (error) {
            console.error("Error posting data:", error);
            return null;
        }
    }

}

export default moveFiles;